import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/basketGreyBackground/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showBasketGreyBackgroundSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showBasketGreyBackgroundSelector };
